module.exports = __webpack_public_path__ + "static/see-the-person-left-8db920840ac68afc5e8fb4542d2fa48e.png";